import category_1 from "../assets/category-1.png";
import category_2 from "../assets/category-2.png";
import category_3 from "../assets/category-3.png";
import men_1 from "../assets/men-1.png";
import men_2 from "../assets/men-2.png";
import men_3 from "../assets/men-3.png";
import men_4 from "../assets/men-4.png";
import men_5 from "../assets/men-5.png";
import unisex_1 from "../assets/unisex-1.png";
import unisex_2 from "../assets/unisex-2.png";
import unisex_3 from "../assets/unisex-3.png";
import unisex_4 from "../assets/unisex-4.png";
import unisex_5 from "../assets/unisex-5.png";
import women_1 from "../assets/women-1.png";
import women_2 from "../assets/women-2.png";
import women_3 from "../assets/women-3.png";
import women_4 from "../assets/women-4.png";
import women_5 from "../assets/women-5.png";
import cate_1 from "../assets/icons/cate-1.png";
import cate_2 from "../assets/icons/cate-2.png";
import cate_3 from "../assets/icons/cate-3.png";

export const category = [
  {
    id: 1,
    title: "Men Fragrances",
    image: category_1,
  },
  {
    id: 2,
    title: "Unisex Fragrances",
    image: category_2,
  },
  {
    id: 3,
    title: "Women Fragrances",
    image: category_3,
  },
];

export const men = [
  {
    id: 1,
    title: "New Arrivals",
    products: [
      {
        id: 1,
        title: "Qimmah",
        perfumeBy: "Eau De Parfum",
        price: 15.95,
        image: men_1,
      },
      {
        id: 2,
        title: "Club de Nuit Milestone",
        perfumeBy: "Eau De Parfum",
        price: 36.95,
        image: men_2,
      },
      {
        id: 3,
        title: "Ameer Al Oud",
        perfumeBy: "Eau De Parfum",
        price: 58.95,
        image: men_3,
      },
      {
        id: 4,
        title: "Le Male Elixir",
        perfumeBy: "Eau De Parfum",
        price: 114.95,
        image: men_4,
      },
      {
        id: 5,
        title: "Spicebomb Infrared",
        perfumeBy: "Eau De Parfum",
        price: 65.95,
        image: men_5,
      },
    ],
  },
  {
    id: 2,
    title: "Best Sales",
    products: [
      {
        id: 1,
        title: "Qimmah",
        perfumeBy: "Eau De Parfum",
        price: 15.95,
        image: unisex_1,
      },
      {
        id: 2,
        title: "Club de Nuit Milestone",
        perfumeBy: "Eau De Parfum",
        price: 36.95,
        image: unisex_2,
      },
      {
        id: 3,
        title: "Ameer Al Oud",
        perfumeBy: "Eau De Parfum",
        price: 58.95,
        image: unisex_3,
      },
      {
        id: 4,
        title: "Le Male Elixir",
        perfumeBy: "Eau De Parfum",
        price: 114.95,
        image: unisex_4,
      },
      {
        id: 5,
        title: "Spicebomb Infrared",
        perfumeBy: "Eau De Parfum",
        price: 65.95,
        image: unisex_5,
      },
    ],
  },
  {
    id: 3,
    title: "Featured",
    products: [
      {
        id: 1,
        title: "Qimmah",
        perfumeBy: "Eau De Parfum",
        price: 15.95,
        image: women_1,
      },
      {
        id: 2,
        title: "Club de Nuit Milestone",
        perfumeBy: "Eau De Parfum",
        price: 36.95,
        image: women_2,
      },
      {
        id: 3,
        title: "Ameer Al Oud",
        perfumeBy: "Eau De Parfum",
        price: 58.95,
        image: women_3,
      },
      {
        id: 4,
        title: "Le Male Elixir",
        perfumeBy: "Eau De Parfum",
        price: 114.95,
        image: women_4,
      },
      {
        id: 5,
        title: "Spicebomb Infrared",
        perfumeBy: "Eau De Parfum",
        price: 65.95,
        image: women_5,
      },
    ],
  },
];

export const women = [
  {
    id: 1,
    title: "New Arrivals",
    products: [
      {
        id: 1,
        title: "Qimmah",
        perfumeBy: "Eau De Parfum",
        price: 15.95,
        image: women_1,
      },
      {
        id: 2,
        title: "Club de Nuit Milestone",
        perfumeBy: "Eau De Parfum",
        price: 36.95,
        image: women_2,
      },
      {
        id: 3,
        title: "Ameer Al Oud",
        perfumeBy: "Eau De Parfum",
        price: 58.95,
        image: women_3,
      },
      {
        id: 4,
        title: "Le Male Elixir",
        perfumeBy: "Eau De Parfum",
        price: 114.95,
        image: women_4,
      },
      {
        id: 5,
        title: "Spicebomb Infrared",
        perfumeBy: "Eau De Parfum",
        price: 65.95,
        image: women_5,
      },
    ],
  },
  {
    id: 2,
    title: "Best Sales",
    products: [
      {
        id: 1,
        title: "Qimmah",
        perfumeBy: "Eau De Parfum",
        price: 15.95,
        image: men_1,
      },
      {
        id: 2,
        title: "Club de Nuit Milestone",
        perfumeBy: "Eau De Parfum",
        price: 36.95,
        image: men_2,
      },
      {
        id: 3,
        title: "Ameer Al Oud",
        perfumeBy: "Eau De Parfum",
        price: 58.95,
        image: men_3,
      },
      {
        id: 4,
        title: "Le Male Elixir",
        perfumeBy: "Eau De Parfum",
        price: 114.95,
        image: men_4,
      },
      {
        id: 5,
        title: "Spicebomb Infrared",
        perfumeBy: "Eau De Parfum",
        price: 65.95,
        image: men_5,
      },
    ],
  },
  {
    id: 3,
    title: "Featured",
    products: [
      {
        id: 1,
        title: "Qimmah",
        perfumeBy: "Eau De Parfum",
        price: 15.95,
        image: unisex_1,
      },
      {
        id: 2,
        title: "Club de Nuit Milestone",
        perfumeBy: "Eau De Parfum",
        price: 36.95,
        image: unisex_2,
      },
      {
        id: 3,
        title: "Ameer Al Oud",
        perfumeBy: "Eau De Parfum",
        price: 58.95,
        image: unisex_3,
      },
      {
        id: 4,
        title: "Le Male Elixir",
        perfumeBy: "Eau De Parfum",
        price: 114.95,
        image: unisex_4,
      },
      {
        id: 5,
        title: "Spicebomb Infrared",
        perfumeBy: "Eau De Parfum",
        price: 65.95,
        image: unisex_5,
      },
    ],
  },
];
export const unisex = [
  {
    id: 1,
    title: "New Arrivals",
    products: [
      {
        id: 1,
        title: "Qimmah",
        perfumeBy: "Eau De Parfum",
        price: 15.95,
        image: unisex_1,
      },
      {
        id: 2,
        title: "Club de Nuit Milestone",
        perfumeBy: "Eau De Parfum",
        price: 36.95,
        image: unisex_2,
      },
      {
        id: 3,
        title: "Ameer Al Oud",
        perfumeBy: "Eau De Parfum",
        price: 58.95,
        image: unisex_3,
      },
      {
        id: 4,
        title: "Le Male Elixir",
        perfumeBy: "Eau De Parfum",
        price: 114.95,
        image: unisex_4,
      },
      {
        id: 5,
        title: "Spicebomb Infrared",
        perfumeBy: "Eau De Parfum",
        price: 65.95,
        image: unisex_5,
      },
    ],
  },
  {
    id: 2,
    title: "Best Sales",
    products: [
      {
        id: 1,
        title: "Qimmah",
        perfumeBy: "Eau De Parfum",
        price: 15.95,
        image: women_1,
      },
      {
        id: 2,
        title: "Club de Nuit Milestone",
        perfumeBy: "Eau De Parfum",
        price: 36.95,
        image: women_2,
      },
      {
        id: 3,
        title: "Ameer Al Oud",
        perfumeBy: "Eau De Parfum",
        price: 58.95,
        image: women_3,
      },
      {
        id: 4,
        title: "Le Male Elixir",
        perfumeBy: "Eau De Parfum",
        price: 114.95,
        image: women_4,
      },
      {
        id: 5,
        title: "Spicebomb Infrared",
        perfumeBy: "Eau De Parfum",
        price: 65.95,
        image: women_5,
      },
    ],
  },

  {
    id: 3,
    title: "Featured",
    products: [
      {
        id: 1,
        title: "Qimmah",
        perfumeBy: "Eau De Parfum",
        price: 15.95,
        image: men_1,
      },
      {
        id: 2,
        title: "Club de Nuit Milestone",
        perfumeBy: "Eau De Parfum",
        price: 36.95,
        image: men_2,
      },
      {
        id: 3,
        title: "Ameer Al Oud",
        perfumeBy: "Eau De Parfum",
        price: 58.95,
        image: men_3,
      },
      {
        id: 4,
        title: "Le Male Elixir",
        perfumeBy: "Eau De Parfum",
        price: 114.95,
        image: men_4,
      },
      {
        id: 5,
        title: "Spicebomb Infrared",
        perfumeBy: "Eau De Parfum",
        price: 65.95,
        image: men_5,
      },
    ],
  },
];

export const cate = [
  {
    id: 1,
    title: "Free (U.S) Shipping Over",
    price: "$59.95",
    detail: "Worldwide Shipping rates will be calculated at the checkout page",
    icon: cate_1,
  },
  {
    id: 2,
    title: "Secure Payment",
    secure: "100%",
    detail: "We ensure secure payment with PEV",
    icon: cate_2,
  },
  {
    id: 3,
    title: "Days Return",
    secure: "30",
    detail: "Returned within 30 days of the delivery date",
    icon: cate_3,
  },
];

export const cart = [
  {
    id: 1,
    title: "Qimmah",
    perfumeBy: "Eau De Parfum",
    price: 15.95,
    privous: 25.95,
    image: unisex_1,
  },
  {
    id: 2,
    title: "Club de Nuit Milestone",
    perfumeBy: "Eau De Parfum",
    price: 36.95,
    privous: 55.95,
    image: unisex_2,
  },
  {
    id: 3,
    title: "Ameer Al Oud",
    perfumeBy: "Eau De Parfum",
    price: 58.95,
    privous: 75.95,
    image: unisex_3,
  },
  {
    id: 4,
    title: "Le Male Elixir",
    perfumeBy: "Eau De Parfum",
    price: 114.95,
    privous: 125.95,
    image: unisex_4,
  },
  {
    id: 5,
    title: "Spicebomb Infrared",
    perfumeBy: "Eau De Parfum",
    price: 65.95,
    privous: 85.95,
    image: unisex_5,
  },
];
